import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import { ITag } from '@fluentui/react';
import { Field, Input, FluentProvider, webLightTheme } from '@fluentui/react-components';
import React from 'react';
import { Controller, FieldValues, UseFormMethods } from 'react-hook-form';
import CompanyPicker from '../companyGroups/detail/CompanyGroupCompanyPicker';
import { SHADOW_COMPANY_NAME_SUFFIX } from './details/types';

interface INewShadowCompanyFormProps {
  form: UseFormMethods<FieldValues>;
}

const NewShadowCompanyForm = ({ form }: INewShadowCompanyFormProps): JSX.Element => {
  const { control, errors } = form;
  const shadowCompanyNameLength = 25 - SHADOW_COMPANY_NAME_SUFFIX.length;

  return (
    <FluentProvider theme={webLightTheme}>
      <Stack tokens={{ childrenGap: 10 }}>
        <Controller
          id="parentCompany"
          name="parentCompany"
          control={control}
          defaultValue={[]}
          render={({ onChange, value }): React.ReactElement => (
            <CompanyPicker
              selectedItems={value}
              itemLimit={1}
              setSelectedItems={onChange}
              required
              errorMessage={errors?.parentCompany?.message}
              label="Parent Company"
            />
          )}
          rules={{
            validate: (value: ITag[]): boolean | string =>
              (value && value.length > 0) || 'Please select a parent company',
          }}
        />
        <Controller
          control={control}
          name="shadowCompanyName"
          rules={{
            required: 'Please enter a name',
            maxLength: {
              value: shadowCompanyNameLength,
              message: `Shadow Company Name can only be a max of ${shadowCompanyNameLength} characters`,
            },
          }}
          render={({ onChange, onBlur, value, name, ref }) => (
            <Field
              label="Shadow Company Name"
              required
              validationMessage={errors?.shadowCompanyName?.message}
            >
              <Input
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                name={name}
                ref={ref}
                id="shadowCompanyName"
                contentAfter={SHADOW_COMPANY_NAME_SUFFIX}
              />
            </Field>
          )}
        />
      </Stack>
    </FluentProvider>
  );
};

export default NewShadowCompanyForm;
